import { Component, HostBinding } from "@angular/core";

@Component({
	selector: 'slick-container-footer',
	template: `<ng-content></ng-content>`
})
export class SlickContainerFooterComponent {
	@HostBinding("class") slickContainerFooter = 'slick-container-footer';
}
